module.exports = {"id":"193476","name":"Rémy Cabella","rating":"77","photo":"./data/images/photos/0/193476.png","club":{"name":"ASSE","logo":"./data/images/clubs/ASSE.png"},"positions":["MOC","AG","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RemyCabella0.json
// module id = 3565
// module chunks = 0